// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   Grid,
//   Button,
//   InputAdornment,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Autocomplete } from "@mui/material";
// import ApiServices from "../../../Utils/ApiServices/ApiServices";
// import {
//   getDecryptedAccessToken,
//   getDecryptedData,
//   getDecryptedUserType,
// } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
// import Loader from "../../../Container/Loader/Loader";
// import { useParams } from "react-router-dom";

// const apiEndpoints = {
//   "Allergy issue list": "allergy_issue_list",
//   "Issue Subtypes": "issue_subtypes",
//   "Occurrence": "occurrence",
//   "Severity": "severity_ccda",
//   "Reaction": "reaction",
//   "Condition verification status codes": "condition-verification",
//   "Allergyintolerance verification status codes": "allergyintolerance-verification",
//   "Outcome": "outcome",
// };

// const UpdateAllergiesDialog = () => {
//   const [apiData, setApiData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [selectedData, setSelectedData] = useState({});
//   const [beginDate, setBeginDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [submitting, setSubmitting] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

//   const accessToken = getDecryptedAccessToken();
//   const LoginUserDetails = getDecryptedData();
//   const LoginUserType = getDecryptedUserType();
//   const params = useParams()
//   const userUUID = LoginUserType === 'Patient' ? LoginUserDetails?.uuid : params?.uuid;
//   // const userUUID = LoginUserDetails?.uuid;

//   const API_BASE_URL = LoginUserType === "Patient" ? "/apis/default/portal/list/" : "/apis/default/api/list/";

//   useEffect(() => {
//     fetchAllergyData();
//   }, [accessToken]);

//   const fetchAllergyData = async () => {
//     setLoading(true);
//     try {
//       const apiCalls = Object.entries(apiEndpoints).map(([key, endpoint]) =>
//         ApiServices.get(`${API_BASE_URL}${endpoint}`, {
//           Authorization: `Bearer ${accessToken}`,
//         }).then((res) => ({ [key]: res.data }))
//       );

//       const results = await Promise.all(apiCalls);
//       const combinedData = results.reduce((acc, data) => ({ ...acc, ...data }), {});

//       setApiData(combinedData);
//     } catch (error) {
//       console.error("Error fetching allergy data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSelectChange = (category, value) => {
//     setSelectedData((prev) => ({
//       ...prev,
//       [category]: value || null,
//     }));
//   };

//   const handleSubmit = async () => {
//     setSubmitting(true);
//     try {
//       const payload = {
//         subtype: selectedData["Issue Subtypes"]?.option_id || "",
//         title: selectedData["Allergy issue list"]?.title || "",
//         outcome: selectedData["Outcome"]?.option_id || "",
//         reaction: selectedData["Reaction"]?.option_id || "",
//         verification: selectedData["Allergyintolerance verification status codes"]?.option_id || "",
//         severity_al: selectedData["Severity"]?.option_id || "",
//         list_option_id: selectedData["Allergy issue list"]?.option_id || "",
//         begdate: beginDate ? `${beginDate} 00:00:00` : "",
//         enddate: endDate ? `${endDate} 00:00:00` : "",
//       };

//       await ApiServices.post(`/apis/default/portal/patient/${userUUID}/allergy`, payload, {
//         Authorization: `Bearer ${accessToken}`,
//       });

//       setSnackbar({ open: true, message: "Allergy updated successfully!", severity: "success" });
//       setSelectedData({});
//       setBeginDate("");
//       setEndDate("");
//     } catch (error) {
//       setSnackbar({ open: true, message: "Failed to update allergy.", severity: "error" });
//       console.error("Error submitting allergy data:", error);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Box p={3}>
//       <Typography variant="h6" mb={3} fontWeight={600}>
//         Update Allergy Data
//       </Typography>

//       {loading ? (
//         <Box display="flex" justifyContent="center">
//           <Loader />
//         </Box>
//       ) : (
//         <Grid container spacing={3}>
//           {Object.keys(apiData).map((category) => (
//             <Grid item xs={12} sm={4} key={category}>
//               <Typography fontWeight={600} mb={1} sx={{ textAlign: "left" }}>
//                 {category}
//               </Typography>
//               <Autocomplete
//                 fullWidth
//                 options={apiData[category] || []}
//                 getOptionLabel={(option) => option.title}
//                 value={selectedData[category] || null}
//                 onChange={(event, newValue) => handleSelectChange(category, newValue)}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     placeholder={`Search ${category}...`}
//                     variant="outlined"
//                     size="small"
//                     InputProps={{
//                       ...params.InputProps,
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <SearchIcon color="disabled" />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 )}
//               />
//             </Grid>
//           ))}

//           <Grid item xs={12} sm={4}>
//           <Typography fontWeight={600} mb={1} sx={{textAlign:"left"}}>
//               Begin Date
//             </Typography>
//             <TextField type="date" value={beginDate} onChange={(e) => setBeginDate(e.target.value)} fullWidth size="small" />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//           <Typography fontWeight={600} mb={1} sx={{textAlign:"left"}}>
//               End Date
//             </Typography>
//             <TextField type="date"  value={endDate} onChange={(e) => setEndDate(e.target.value)} fullWidth size="small" />
//             <Typography variant="caption" color="textSecondary">
//                If the allergy is still present, keep the End Date empty.
//             </Typography>
//           </Grid>
//         </Grid>
//       )}

//       <Box mt={3} textAlign="right">
//         <Button variant="contained" color="primary" onClick={handleSubmit} disabled={submitting}>
//           {submitting ? "Uploading Allergy..." : "Submit"}
//         </Button>
//       </Box>

//       <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
//         <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default UpdateAllergiesDialog;



import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  InputAdornment,
  Snackbar,
  Alert,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Autocomplete } from "@mui/material";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import {
  getDecryptedAccessToken,
  getDecryptedData,
  getDecryptedUserType,
} from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import Loader from "../../../Container/Loader/Loader";
import { useParams } from "react-router-dom";

const apiEndpoints = {
  "Allergy issue list": "allergy_issue_list",
  "Issue Subtypes": "issue_subtypes",
  "Occurrence": "occurrence",
  "Severity": "severity_ccda",
  "Reaction": "reaction",
  "Condition verification status codes": "condition-verification",
  "Allergyintolerance verification status codes": "allergyintolerance-verification",
  "Outcome": "outcome",
};

const UpdateAllergiesDialog = () => {
  const [apiData, setApiData] = useState({});
  const [allergyList, setAllergyList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedData, setSelectedData] = useState({});
  const [beginDate, setBeginDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const accessToken = getDecryptedAccessToken();
  const LoginUserDetails = getDecryptedData();
  const LoginUserType = getDecryptedUserType();
  const params = useParams();
  const userUUID = LoginUserType === "Patient" ? LoginUserDetails?.uuid : params?.uuid;

  const API_BASE_URL = LoginUserType === "Patient" ? "/apis/default/portal" : "/apis/default/api";

  useEffect(() => {
    fetchAllergyData();
    fetchAllergyList();
  }, [accessToken]);

  const fetchAllergyData = async () => {
    setLoading(true);
    try {
      const apiCalls = Object.entries(apiEndpoints).map(([key, endpoint]) =>
        ApiServices.get(`${API_BASE_URL}/list/${endpoint}`, {
          Authorization: `Bearer ${accessToken}`,
        }).then((res) => ({ [key]: res.data }))
      );

      const results = await Promise.all(apiCalls);
      const combinedData = results.reduce((acc, data) => ({ ...acc, ...data }), {});
      setApiData(combinedData);
    } catch (error) {
      console.error("Error fetching allergy dropdown data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllergyList = async () => {
    try {
      const response = await ApiServices.get(`${API_BASE_URL}/patient/${userUUID}/allergy`, {
        Authorization: `Bearer ${accessToken}`,
      });
      setAllergyList(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching allergy list:", error);
    }
  };

  const handleSelectChange = (category, value) => {
    setSelectedData((prev) => ({
      ...prev,
      [category]: value || null,
    }));
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const payload = {
        subtype: selectedData["Issue Subtypes"]?.option_id || "",
        title: selectedData["Allergy issue list"]?.title || "",
        outcome: selectedData["Outcome"]?.option_id || "",
        reaction: selectedData["Reaction"]?.option_id || "",
        verification: selectedData["Allergyintolerance verification status codes"]?.option_id || "",
        severity_al: selectedData["Severity"]?.option_id || "",
        list_option_id: selectedData["Allergy issue list"]?.option_id || "",
        begdate: beginDate ? `${beginDate} 00:00:00` : "",
        enddate: endDate ? `${endDate} 00:00:00` : "",
      };

      await ApiServices.post(`${API_BASE_URL}/patient/${userUUID}/allergy`, payload, {
        Authorization: `Bearer ${accessToken}`,
      });

      setSnackbar({ open: true, message: "Allergy updated successfully!", severity: "success" });
      setSelectedData({});
      setBeginDate("");
      setEndDate("");
      fetchAllergyList(); // Refresh table after submission
    } catch (error) {
      setSnackbar({ open: true, message: "Failed to update allergy.", severity: "error" });
      console.error("Error submitting allergy data:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h6" mb={3} fontWeight={600}>
        Update Allergy Data
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center">
          <Loader />
        </Box>
      ) : (
        <Grid container spacing={3}>
          {Object.keys(apiData).map((category) => (
            <Grid item xs={12} sm={4} key={category}>
              <Typography fontWeight={600} mb={1} sx={{ textAlign: "left" }}>
                {category}
              </Typography>
              <Autocomplete
                fullWidth
                options={apiData[category] || []}
                getOptionLabel={(option) => option.title}
                value={selectedData[category] || null}
                onChange={(event, newValue) => handleSelectChange(category, newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={`Search ${category}...`}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="disabled" />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
          ))}

          <Grid item xs={12} sm={4}>
            <Typography fontWeight={600} mb={1} sx={{ textAlign: "left" }}>
              Begin Date
            </Typography>
            <TextField
              type="date"
              value={beginDate}
              onChange={(e) => setBeginDate(e.target.value)}
              fullWidth
              size="small"
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography fontWeight={600} mb={1} sx={{ textAlign: "left" }}>
              End Date
            </Typography>
            <TextField
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              fullWidth
              size="small"
            />
            <Typography variant="caption" color="textSecondary">
              If the allergy is still present, keep the End Date empty.
            </Typography>
          </Grid>
        </Grid>
      )}

      <Box mt={3} textAlign="right">
        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={submitting}>
          {submitting ? "Uploading Allergy..." : "Submit"}
        </Button>
      </Box>

      {/* Allergy Table */}
      <Box mt={5}>
        <Typography variant="h6" mb={2} fontWeight={600}>
          Existing Allergies
        </Typography>
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>Subtype</TableCell>
                <TableCell>Reaction</TableCell>
                <TableCell>Severity</TableCell>
                <TableCell>Verification</TableCell>
                <TableCell>Begin Date</TableCell>
                <TableCell>End Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allergyList.length > 0 ? (
                allergyList.map((item) => (
                  <TableRow key={item.allergy_uuid}>
                    <TableCell>{item.title}</TableCell>
                    <TableCell>{item.subtype}</TableCell>
                    <TableCell>{item.reaction_title}</TableCell>
                    <TableCell>{item.severity_al}</TableCell>
                    <TableCell>{item.verification_title || item.verification}</TableCell>
                    <TableCell>{item.begdate?.split(" ")[0]}</TableCell>
                    <TableCell>{item.enddate?.split(" ")[0] || "Ongoing"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No allergy records found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UpdateAllergiesDialog;
